import VIEWPORTS from '../plugins/viewports'
import PARTSLOADER from '../plugins/partsloader'
import CONTENT_TITLE from '../plugins/contentTitle'
import SCROLL from '../modules/scroll'

// スクロールして画面エリアに入ったら要素を表示する lazydisp
import LAZYDISP from '../plugins/lazydisp'

// カレンダーカスタマイズ
// import FULLCALENDAR from '../plugins/fullcalendar'

// IE11でSVGの外部参照を有効にする
import 'svgxuse'

const [w,d,l] = [window, document, location];

export default function INIT() {
  /*****
   * Promise
   */
  window.load = {
    'header': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'contentFooter': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'footer': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'mapScript': new $.Deferred, // googlemapAPIのURLパラメータでresolveします
    'loadHtml': new $.Deferred, // すべてのLoad Htmlが完了したらresolveする
  }

  VIEWPORTS() // Viewportの置き換え
  
  //header.html, footer.html読み込み
  PARTSLOADER([
    {
      name: 'footer',
      loadhtml: ( l.pathname + l.search !== '/service/?mode=detail&article=2' )? '/asset/html/footer.html' : '/asset/html/baritori-footer.html?ts=20220221',
      target: 'footer',
      method:'replaceWith',
      callback(){
        $('footer [data-plugin="getCopyright"]').getCopyright()

        // バリ取り男塾LP スクロールイベント
        if( l.pathname + l.search == '/service/?mode=detail&article=2') {
          let $fixbtn = $('.baritori-footer-fixNav')

          SCROLL({
            scrollUp(){
              if( !$fixbtn.hasClass('is-active') ) $fixbtn.addClass('is-active')
            },
            scrollDown(){
              if( $fixbtn.hasClass('is-active') && !$fixbtn.hasClass('is-intersect') ) $fixbtn.removeClass('is-active')
            }
          })
        }

      }
    },
    {
      name: 'header',
      loadhtml: ( l.pathname + l.search !== '/service/?mode=detail&article=2' )? '/asset/html/header.html' : '/asset/html/baritori-header.html?ts=20220221',
      target: 'header',
      method:'replaceWith',
      callback(r,_){
        $('header .p-gnav').currentMenu({mode:1,default:999});
        const mq = window.matchMedia( "(min-width: 900px)" )
        const $logos = $('.p-header__logo img[data-home-src]')
        const checkBreakpoint = (mq) => {
          if( l.pathname.replace(/(main|index)\.php/,'') === '/' && mq.matches ){
            $logos.each( (i,o) => $(o).attr({ 'src': o.dataset.homeSrc }) )
          }else{
            $logos.each( (i,o) => $(o).attr({ 'src': o.dataset.defaultSrc }) )
          }
        }
        mq.addListener( checkBreakpoint )
        checkBreakpoint(mq)
        $('header [data-plugin="getCopyright"]').getCopyright()
      }
    }
  ])
  // プライバシー・会社概要・サイトマップのコンテンツタイトル
  CONTENT_TITLE({
    'sitemap':'サイトマップ',
    'privacy':'プライバシーポリシー',
    'profile':'会社概要'
  })

  const getWinHeight = () => {
    setTimeout(() => {
      // ビューポートの高さを取得し、0.01を掛けて1%の値を算出して、vh単位の値を取得
      let vh = window.innerHeight * 0.01
      // カスタム変数--vhの値をドキュメントのルートに設定
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }, 100);
  }
  getWinHeight()
  window.addEventListener('orientationchange', getWinHeight )

  // DOM Ready
  $(() => {
    // <body>にクラス付与
    $.bodyClass();
    
    // htmlデータ読み込み
    $('[data-load-html]').loadHtml();

    // カレントメニュー
    $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});

    // ページングテキスト
    $.pagingText({
      prev:'PREV',
      next:'NEXT',
      list:'LIST'
    })

    // ページトップリンクをスクロール量で表示するサンプル
    $.scrollspy({
      trigger:200,
      onBefore(/* pos */) {
        $('.p-pagetop__wrap').addClass('hidden');
      },
      onAfter() {
        $('.p-pagetop__wrap').removeClass('hidden');
      }
    })

    // lazydisp
    $.when( w.load['loadHtml'] ).then( () => LAZYDISP('[data-lazydisp]') )
  })


}